import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrmeBlogRoutingModule } from './drme-blog-routing.module';
import { DrmeBlogMainComponent } from './drme-blog-main/drme-blog-main.component';
import { HepatitsComponent } from './blogs/hepatits/hepatits.component';
import { BlogSearchComponent } from './blog-search/blog-search.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { BlogMobileSearchComponent } from './blog-search/blog-mobile-search/blog-mobile-search.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import {MatInputModule} from '@angular/material/input';
@NgModule({
  declarations: [DrmeBlogMainComponent, HepatitsComponent, BlogSearchComponent, BlogMobileSearchComponent],
  imports: [
    CommonModule,
    DrmeBlogRoutingModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    HttpClientModule,
    MatBottomSheetModule,
    MatInputModule
  ]
})
export class DrmeBlogModule { }
